<div>
    <p (click)="onReturnToPreviousPage()" class="return-btn">
        <span nz-icon nzType="left" nzTheme="outline"></span> {{'GENERAL.PREVIOUS_PAGE' | translate}}
    </p>
</div>
  
<nz-card [nzBordered]="false" class="ant-card-body-main share-card-wrapper" id="shareHistory">
    <nz-col [nzXs]="24" [nzMd]="24" [nzLg]="24"  [nzXl]="24">
        <div
            nz-col
            class="sharing-table-box"
            nzXs="24"
            nzSm="24"
            nzMd="24"
            nzLg="24"
            nzXl="24"
        >
            <nz-table
                #nzTable
                [nzPageSize]="10"
                [nzSize]="'small'"
                [nzLoading]="isloading"
                [nzLoadingDelay]="'2000'"
                [nzShowPagination]="false"
                [nzData]="sharedHistory"
                nzTableLayout="auto"
                [nzFooter]="pagination"
            >
                <thead>
                    <tr>
                        <th scope="col" nzWidth="50px"></th>
                        <th scope="col">{{'PROVISIONING.SHARE.CANDIDATE_INFORMATION' | translate}}</th>
                        <th scope="col">{{'PROVISIONING.SHARE.CONTACT' | translate}}</th>
                        <th scope="col">{{'GENERAL.STATUS' | translate}}</th>
                        <th scope="col">{{'PROVISIONING.SHARE.SHARED_DATE' | translate}}</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let data of nzTable.data">
                        <td class="institution-wrapper">
                            <img
                            *ngIf="data?.share_type === shareType.INSTITUTION" 
                            [nz-tooltip]="'PROVISIONING.SHARE.INSTITUTION' | translate"
                            class="institution"
                            src="assets/icons/InstitutionIcon_.svg"
                            alt=""
                            />
                        </td>

                        <td>
                            {{ data.candidate.surname }} {{ data.candidate.firstname }}
                            <br />
                            {{ data.candidate_number }}
                            <br />
                            {{ data.candidate.year }}
                        </td>

                        <td>
                            {{ data.email }} <br />
                            {{ data?.institution_name}}
                        </td>

                        <td>{{ data.status === 'SUCCESSFUL' ? ('GENERAL.ENUM.SUCCESSFUL' | translate) : (data.status === "FAILED" ? ('GENERAL.ENUM.FAILED' | translate) : (data.status === 'PENDING' ? ('GENERAL.ENUM.PENDING' | translate) : '')) }}</td>
                        <td>{{ data.created_at | date : 'MMM d, y, h:mm a' }}</td>
                    </tr>
                </tbody>
            </nz-table>
        </div>

    </nz-col>
</nz-card>

<ng-template #pagination>
    <div class="text-right pagination-wrapper">
        <nz-pagination
            [nzPageIndex]="current_page"
            [nzTotal]="total"
            [nzItemRender]="renderItemTemplate"
            [nzShowTotal]="rangeTemplate"
            [nzResponsive]="true"
        ></nz-pagination>

        <ng-template #renderItemTemplate let-type let-page="page">
            <ng-container [ngSwitch]="type">
                <a *ngSwitchCase="'page'" (click)="next(page)">{{ page }}</a>
                <a *ngSwitchCase="'next'" (click)="next(current_page + 1)"
                    ><strong *ngIf="nextPage">{{'GENERAL.NEXT' | translate}}</strong></a
                >
                <a *ngSwitchCase="'prev_5'"> << </a>
                <a *ngSwitchCase="'next_5'">>></a>
            </ng-container>
        </ng-template>

        <ng-template #rangeTemplate let-total>
            {{ from }}-{{ to }} {{'GENERAL.OF' | translate}} {{ total }} {{'GENERAL.ITEMS' | translate}}
        </ng-template>
    </div>
</ng-template>
